import { render } from "./MailboxModal.vue?vue&type=template&id=0b386388"
import script from "./MailboxModal.vue?vue&type=script&lang=js"
export * from "./MailboxModal.vue?vue&type=script&lang=js"
script.render = render

export default script